const state = {
    organismObj: {}
,
};
const getters = {
    getOrganismObj(state) {
        debugger
        return state.organismObj;
    }
};
const mutations = {
    setAntibioticObject(state, payload) {
        debugger
        state.organismObj = payload;
    },
};

export default {
    mutations,
    state,
    getters
};